/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { Link } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { MainFilterHandler } from '../../components/comman/MainFilterHandler';
import { timeAgo, truncateDescription } from '../../utility/CommonFunctions';
import Sanitized from '../../components/comman/Sanitized';
import Newsletter from '../../components/comman/Newsletter';
import { toast } from 'react-toastify';
import BoxLoader from '../../components/Loaders/BoxLoader';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import ArticleModal from './ArticleModal';

const Blog = () => {
  const [state, setState] = useState({
    blogList: [],
    limit: 10,
    page: 1,
    totalPages: 1,
    searchQuery: "",
    isBanner: "isBannerPublished=true"
  });
  const [modal, setModal] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
    control
  } = useForm();
  const [loading, setLoading] = useState(false);

  const toggle = () => {
    setModal(!modal);
  }
  const handleBlogList = async () => {
    const option = {
      method: 'GET',
    }
    try {
      setLoading(true);
      const url = apiUrl.get_blog + MainFilterHandler(state)

      const response = await callApi(url, option);
      if (response?.status === true) {
        setLoading(false);
        // console.log(response);
        setState((pre) => ({
          ...pre,
          blogList: response?.blogs,
          totalPages: response?.pagination?.totalPages,
          page: response?.pagination?.currentPage,
        }))
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      // console.log(err);
    }
  }

  useEffect(() => {
    handleBlogList();
  }, [state?.page, state?.searchQuery]);

  useEffect(() => {
    setTimeout(() => {
      toggle();
    }, 10000);
  }, []);


  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > state?.totalPages) return;
    setState((pre) => ({ ...pre, page: pageNumber }));
  };

  const onSubmit = (data) => {
    setState((prevState) => ({
      ...prevState,
      searchQuery: data?.search
    }));
  };

  return (
    <>
      <Layout>
        {/* <DynamicMetaTags metaString={meta} /> */}
        {/* <!-- BredCrumb-Section --> */}
        <div className="bred_crumb mt-5 pt-5 ">
          <div className="container">
            {/* <!-- shape animation  --> */}
            <span className="banner_shape1"> <img src={`${process.env.PUBLIC_URL}/assets/images/banner-shape1.png`} alt="image" /> </span>
            <span className="banner_shape2"> <img src={`${process.env.PUBLIC_URL}/assets/images/banner-shape2.png`} alt="image" /> </span>
            <span className="banner_shape3"> <img src={`${process.env.PUBLIC_URL}/assets/images/banner-shape3.png`} alt="image" /> </span>

            <div className="bred_text">
              <h1>Our Blogs</h1>
              <div className="search_bar">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group">
                    <input type="text" placeholder="Search here" className="form-control"
                      {...register("search")} />
                    <button className="btn" type="submit" ><i className="icofont-search-1"></i></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Story-Section-Start --> */}
        <section className="row_am latest_story blog_list_story" id="blog">
          {/* <!-- container start --> */}
          <div className="container">
            {/* <!-- row start --> */}
            { }
            <div className="row">
              {/* <!-- story --> */}
              {loading ?
                <div className="col-12" >
                  <BoxLoader />
                </div>
                : state?.blogList && state?.blogList?.length > 0 ? state?.blogList?.map((item) => {
                  return (
                    <Link to={RoutesLink.blog_detail + '/' +
                      item?._id + "/" + item?.slug} state={{ blogData: item }} className="col-md-4" key={item._id}>
                      <div className="story_box" data-aos="fade-up" data-aos-duration="1500">
                        <div className="story_img">
                          <img src={item?.thumbnailImage} alt={item?.thumbnailText} />
                          <span>{timeAgo(item?.createdAt)}</span>
                        </div>
                        <div className="story_text">
                          <div className='nmenewbg'>
                            <h3>{item?.articleName}</h3>
                          </div>
                          <div className='namedesniew'>
                            <Sanitized description={item?.description} />
                          </div>
                          <Link to={RoutesLink.blog_detail + '/' +
                            item?._id + "/" + item?.slug} state={{ blogData: item }}>READ MORE</Link>
                        </div>
                      </div>
                    </Link>
                  )
                }) : <div className="col-md-12 text-center">No Data found!</div>}
            </div>
            {/* <!-- row end --> */}

            {/* <!-- Pagination --> */}
            {state?.totalPages > 1 && <div className="pagination_block">
              <ul>
                {/* Previous Button */}
                <li>
                  <a
                    href={() => false}
                    className={`prev ${state?.page === 1 ? 'disabled' : ''}`}
                    onClick={() => handlePageChange(state?.page - 1)}
                  >
                    <i className="icofont-arrow-left"></i> Prev
                  </a>
                </li>

                {/* Page Numbers */}
                {Array.from({ length: state?.totalPages }, (_, index) => index + 1).map((page) => (
                  <li key={page}>
                    <a
                      href={() => false}
                      className={state?.page === page ? 'active' : ''}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </a>
                  </li>
                ))}

                {/* Next Button */}
                <li>
                  <a
                    href={() => false}
                    className={`next ${state?.page === state?.totalPages ? 'disabled' : ''}`}
                    onClick={() => handlePageChange(state?.page + 1)}
                  >
                    Next <i className="icofont-arrow-right"></i>
                  </a>
                </li>
              </ul>
            </div>}
          </div>
          {/* <!-- container end --> */}
        </section>
        {/* <!-- Story-Section-end --> */}
        {/* <!-- News-Letter-Section-Start --> */}
        <Newsletter />
        {/* <!-- News-Letter-Section-end --> */}

        <ArticleModal isOpen={modal} onClose={toggle} />

      </Layout>
      {/*  */}
    </>
  )
}

export default Blog
